import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loading } from 'adc-ui-components';
import { Redirect } from 'react-router-dom';

import { submitXfiPodReturn } from '../../actions/order';
import { RETURNS_CONFIRMATION_ID, subst } from '../../helpers/routes';

class XfiPodReturn extends Component {
  constructor() {
    super();

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const {
      handleSubmitXfiPodReturn,
    } = this.props;

    handleSubmitXfiPodReturn().then((response) => {
      this.setState({
        returnId: response.returnOrderId,
        loading: false,
      });
    });
  }

  render() {
    const { loading, returnId } = this.state;

    if (loading) {
      return <Loading />;
    }

    return <Redirect to={subst(RETURNS_CONFIRMATION_ID, { id: returnId })} />;
  }
}

const mapDispatchToProps = dispatch => ({
  handleSubmitXfiPodReturn: bindActionCreators(submitXfiPodReturn, dispatch),
});

export default connect(null, mapDispatchToProps)(XfiPodReturn);
